<script>
  import GameClient from "../utils/GameSession";
  import Game from "../Game.svelte";
  export let params = {};

  const id = params.id;
  const client = new GameClient(id);
  const connecting = client.connect(id);
</script>

<section class="container"> 
  {#await connecting then session}
    <Game
      id={session.id}
      puzzle={session.grid}
      answers={session.answers}
      players={session.players}
      playerToken={session.token}
      on:value={(e) => {
        const { index, value, position } = e.detail;
        session.sendValue({ index, value, position });
      }}
      on:move={(e) => {
        const { index, direction } = e.detail;
        session.sendPosition({ index, direction });
      }} 
    />
  {:catch error}
    <p style="color: red">{error.message}</p>
  {/await}
</section>

<style>
  .container {
    max-width: 960px;
    margin: 0 auto;
    padding: 1em;
    font-family: sans-serif;
  }
</style>
